import { IContactInformationForm } from '../../model/forms';
import { default as CandidateType, CandidatePersonType } from '../../model/hros/recruiting/CandidateType';
import { CombinedAddressType } from '../../model/hros/common/communication/AddressTypeArray';
import CommunicationType from '../../model/hros/common/communication/CommunicationType';
import AddressComponentType from '../../model/hros/common/communication/AddressComponentType';
import { DefaultTypeIdentifiersCodeList } from '../../model/hros/common/codelist/DefaultTypeIdentifiersCodeList';
import { FormatName } from './FormatName';
import { FormatAddress } from './FormatAddress';

export function ProfileFormContactToHROS(src: IContactInformationForm, dest: CandidateType) : boolean {
  
  let person: CandidatePersonType = {
    name: {}
  };

  let modified = false;

  if (src.givenName !== undefined) {
    person.name.given = src.givenName.trim();
    modified = true;
  }

  if (src.familyName !== undefined) {
    person.name.family = src.familyName.trim();
    modified = true;
  }

  let formattedName = FormatName(src.givenName, src.familyName);
  if (formattedName !== undefined) {
    person.name.formattedName = formattedName; //No need to trim, the result is already trimmed.
    modified = true;
  }

  let communication: CommunicationType = {};
  let communicationModified: boolean = false;
  if (src.email !== undefined) {
    communication.email = [ { address: src.email.trim() }];
    communicationModified = true;
  }

  if (src.phone !== undefined) {
    communication.phone = [ { formattedNumber: src.phone.trim() }];
    communicationModified = true;
  }

  let formattedAddress = FormatAddress(src.address, src.city, src.state, src.postalCode, src.country);
  if (formattedAddress !== undefined) {
    let address: CombinedAddressType = {
      formattedAddress: formattedAddress //No need to trim, the result is already trimmed.
    };

    if (src.address !== undefined) {
      address.line = src.address.trim();
    }
    
    if (src.city !== undefined) {
      address.city = src.city.trim();
    }
    
    if (src.postalCode !== undefined) {
      address.postalCode = src.postalCode.trim();
    }
    
    if (src.country !== undefined) {
      address.countryCode = src.country.trim();
    }

    if (src.state !== undefined) {
      address.countrySubDivisions = [
        {
          type: DefaultTypeIdentifiersCodeList.COUNTRY_SUB_DIVISION_STATE,
          value: src.state.trim()
        }
      ];
    }

    communication.address = [
      address
    ];
    communicationModified = true;
  }

  if (communicationModified) {
    person.communication = communication;
    modified = true;
  }

  if (!modified) {
    return false; //Intial State, nothing to change
  }

  dest.person = person;
  return true;
}

export function HROSToProfileFormContact(src: CandidateType, dest: IContactInformationForm) {
  if (src?.person?.name?.given !== undefined) {
    dest.givenName = src.person.name.given;
  }

  if (src?.person?.name?.family !== undefined) {
    dest.familyName = src.person.name.family;
  }

  if (src?.person?.communication?.email?.[0]?.address !== undefined) {
    dest.email = src.person.communication.email[0].address;
  }

  if (src?.person?.communication?.phone?.[0]?.formattedNumber !== undefined) {
    dest.phone = src.person.communication.phone[0].formattedNumber;
  }

  if (src?.person?.communication?.address?.[0]?.line !== undefined) {
    dest.address = src.person.communication.address[0].line;
  }

  if (src?.person?.communication?.address?.[0]?.city !== undefined) {
    dest.city = src.person.communication.address[0].city;
  }

  if (src?.person?.communication?.address?.[0]?.countrySubDivisions !== undefined) {
    let state = src.person.communication.address[0].countrySubDivisions.find((value: AddressComponentType) => value.type?.toUpperCase() === DefaultTypeIdentifiersCodeList.COUNTRY_SUB_DIVISION_STATE);
    if (state?.value !== undefined) {
      dest.state = state.value;
    }
  }

  if (src?.person?.communication?.address?.[0]?.postalCode !== undefined) {
    dest.postalCode = src.person.communication.address[0].postalCode;
  }

  if (src?.person?.communication?.address?.[0]?.countryCode !== undefined) {
    dest.country = src.person.communication.address[0].countryCode;
  }
}